import request from '~/utils/request';

import { SET_GENERAL_SETTINGS, SET_USER_DATA } from './action-types';

const fetchGeneralSetting = () => async (dispatch) => {
  try {
    const setting = await request.get('/general-settings');
    dispatch({ type: SET_GENERAL_SETTINGS, payload: setting.data.data });
    return setting;
  } catch (error) {
    return error;
  }
};

const updateGeneralSetting = (payload) => async () => {
  try {
    const update = await request.post('/general-settings', payload);
    return update;
  } catch (error) {
    return error;
  }
};

// Update organization (company) name and address
// payload shape: { name: string, address: string }
const updateOrganization = (payload) => async (dispatch) => {
  try {
    const response = await request.patch('/users/update-organization', payload);

    // If backend returns updated user/org in the same /auth/me shape, optionally refresh user
    // Best effort: fetch latest user data to keep Redux in sync if endpoint supports it
    try {
      const me = await request.post('auth/me');
      dispatch({ type: SET_USER_DATA, payload: me.data.data });
    } catch (e) {
      // Silently ignore if refresh fails; caller can choose to refetch later
    }

    return response;
  } catch (error) {
    return error;
  }
};

export { fetchGeneralSetting, updateGeneralSetting, updateOrganization };
